export const StateTenantIdMapping = [
    { name: 'ANDAMAN AND NICOBAR', id: '1', stateCode: 'AN', tenentId: 'dynamic_lokos_an' },
    { name: 'ANDHRA PRADESH', id: '2', stateCode: 'AP', tenentId: 'dynamic_lokos_ap' },
    { name: 'ARUNACHAL PRADESH', id: '3', stateCode: 'AR', tenentId: 'dynamic_lokos_ar' },
    { name: 'ASSAM', id: '4', stateCode: 'AS', tenentId: 'dynamic_lokos_as' },
    { name: 'BIHAR', id: '5', stateCode: 'BR', tenentId: 'dynamic_lokos_bh' },
    { name: 'CHANDIGARH', id: '6', stateCode: 'CH', tenentId: 'dynamic_lokos_ch' },
    { name: 'DELHI', id: '7', stateCode: 'DL', tenentId: 'dynamic_lokos_dl' },
    { name: 'GOA', id: '8', stateCode: 'GA', tenentId: 'dynamic_lokos_go' },
    { name: 'GUJARAT', id: '9', stateCode: 'GJ', tenentId: 'dynamic_lokos_gj' },
    { name: 'HARYANA', id: '10', stateCode: 'HR', tenentId: 'dynamic_lokos_ha' },
    { name: 'HIMACHAL PRADESH', id: '11', stateCode: 'HP', tenentId: 'dynamic_lokos_hp' },
    { name: 'JAMMU AND KASHMIR', id: '12', stateCode: 'JK', tenentId: 'dynamic_lokos_jk' },
    { name: 'KARNATAKA', id: '13', stateCode: 'KA', tenentId: 'dynamic_lokos_kn' },
    { name: 'KERALA', id: '14', stateCode: 'KL', tenentId: 'dynamic_lokos_kr' },
    { name: 'MADHYA PRADESH', id: '15', stateCode: 'MP', tenentId: 'dynamic_lokos_mp' },
    { name: 'MAHARASHTRA', id: '16', stateCode: 'MH', tenentId: 'dynamic_lokos_mh' },
    { name: 'LAKSHADWEEP', id: '17', stateCode: 'LD', tenentId: 'dynamic_lokos_la' },
    { name: 'MANIPUR', id: '18', stateCode: 'MN', tenentId: 'dynamic_lokos_mn' },
    { name: 'MEGHALAYA', id: '19', stateCode: 'ML', tenentId: 'dynamic_lokos_mg' },
    { name: 'MIZORAM', id: '20', stateCode: 'MZ', tenentId: 'dynamic_lokos_mz' },
    { name: 'NAGALAND', id: '21', stateCode: 'NL', tenentId: 'dynamic_lokos_ng' },
    { name: 'ODISHA', id: '22', stateCode: 'OR', tenentId: 'dynamic_lokos_or' },
    { name: 'PUDUCHERRY', id: '23', stateCode: 'PY', tenentId: 'dynamic_lokos_po' },
    { name: 'PUNJAB', id: '24', stateCode: 'PN', tenentId: 'dynamic_lokos_pj' },
    { name: 'RAJASTHAN', id: '25', stateCode: 'RJ', tenentId: 'dynamic_lokos_rj' },
    { name: 'SIKKIM', id: '26', stateCode: 'SK', tenentId: 'dynamic_lokos_sk' },
    { name: 'TAMIL NADU', id: '27', stateCode: 'TN', tenentId: 'dynamic_lokos_tn' },
    { name: 'TRIPURA', id: '28', stateCode: 'TR', tenentId: 'dynamic_lokos_tr' },
    { name: 'UTTAR PRADESH', id: '29', stateCode: 'UP', tenentId: 'dynamic_lokos_up' },
    { name: 'WEST BENGAL', id: '30', stateCode: 'WB', tenentId: 'dynamic_lokos_wb' },
    { name: 'CHHATTISGARH', id: '31', stateCode: 'CG', tenentId: 'dynamic_lokos_cg' },
    { name: 'JHARKHAND', id: '32', stateCode: 'JH', tenentId: 'dynamic_lokos_jh' },
    { name: 'UTTARAKHAND', id: '33', stateCode: 'UK', tenentId: 'dynamic_lokos_uk' },
    { name: 'TELANGANA', id: '34', stateCode: 'TS', tenentId: 'dynamic_lokos_ts' },
    { name: 'LADAKH', id: '35', stateCode: 'LA', tenentId: 'dynamic_lokos_ld' },
    { name: 'DADRA AND NAGAR HAVELI AND DAMAN AND DIU', id: '36', stateCode: 'DD', tenentId: 'dynamic_lokos_dn' },
]; 